import React, { createContext, useState, useEffect } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [profilePic, setProfilePic] = useState('');

  const syncFromLocalStorage = () => {
    const storedPic = localStorage.getItem('userPic');
    if (storedPic) {
      setProfilePic(storedPic); // ✅ allow both http and base64
    } else {
      setProfilePic('');
    }
  };

  useEffect(() => {
    // Sync on load
    syncFromLocalStorage();

    // Re-sync when other tabs/windows update it
    const onAuthChange = () => {
      syncFromLocalStorage();
    };

    window.addEventListener('auth-change', onAuthChange);
    return () => window.removeEventListener('auth-change', onAuthChange);
  }, []);

  const updateProfilePic = (newPic) => {
    if (newPic) {
      localStorage.setItem('userPic', newPic); // ✅ always save
      setProfilePic(newPic);
    } else {
      localStorage.removeItem('userPic');
      setProfilePic('');
    }

    // Notify all components using context to refresh
    window.dispatchEvent(new Event('auth-change'));
  };

  return (
    <UserContext.Provider value={{ profilePic, updateProfilePic }}>
      {children}
    </UserContext.Provider>
  );
};